import Seo, { SITE_NAME, SITE_SLOGAN, SITE_URL } from '@/components/feature/Seo';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/feature/BackToTop';
import SectionHeading from '@/components/base/SectionHeading';
import FaqAccordion from '@/components/feature/FaqAccordion';
import { faqs } from '@/mocks/faqs';
import HeroSection from '@/pages/home/components/HeroSection';
import HotRanking from '@/pages/home/components/HotRanking';
import RankingAside from '@/pages/home/components/RankingAside';
import FeaturedScenes from '@/pages/home/components/FeaturedScenes';
import HotCommentsSection from '@/pages/home/components/HotCommentsSection';
import DanmakuWall from '@/pages/home/components/DanmakuWall';
import GroupChatSection from '@/pages/home/components/GroupChatSection';
import CategorySection from '@/pages/home/components/CategorySection';
import JoinCta from '@/pages/home/components/JoinCta';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    alternateName: '糖心吃瓜官网',
    url: SITE_URL,
    description: SITE_SLOGAN,
    inLanguage: 'zh-CN',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${SITE_URL}/topics?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE_NAME,
    url: SITE_URL,
    description: '聚合互联网热评、弹幕、名场面与群聊高能片段的玩梗文化门户。',
    email: 'hello@tangxinchigua.cn',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: `${SITE_NAME}官网 - 玩梗现场与名场面汇总`,
    url: SITE_URL,
    inLanguage: 'zh-CN',
    description:
      '糖心吃瓜官网汇总糖心吃瓜热评、弹幕、名场面与群聊高能片段，围观最热闹的玩梗现场。',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.a,
      },
    })),
  },
];

export default function Home() {
  return (
    <>
      <Seo
        title="糖心吃瓜官网 | 热评·弹幕·名场面·群聊玩梗现场直击"
        description="糖心吃瓜官网汇总糖心吃瓜热评、弹幕、名场面与群聊高能片段。梗图、神评、接梗不断，来这里跟网友一起刷屏玩梗不冷场。"
        keywords="糖心吃瓜,糖心吃瓜官网,热评,弹幕,名场面,玩梗,群聊"
        path="/"
        jsonLd={homeJsonLd}
      />

      <Navbar brandAsH1 transparentOnTop />

      <main>
        <HeroSection />

        <section id="ranking" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
          <div className="mx-auto max-w-content px-4 md:px-6">
            <SectionHeading
              eyebrow="今日热榜"
              title="现在最热闹的玩梗现场"
              description="每一条都标注了类型和热度，点开就能看到完整现场、高能台词与网友热评。"
            />
            <div className="mt-8 grid gap-6 lg:grid-cols-[1fr_340px]">
              <HotRanking />
              <RankingAside />
            </div>
          </div>
        </section>

        <FeaturedScenes />

        <HotCommentsSection />

        <DanmakuWall />

        <GroupChatSection />

        <CategorySection />

        <section id="faq" className="scroll-mt-24 bg-background-100 py-14 md:py-20">
          <div className="mx-auto max-w-content px-4 md:px-6">
            <SectionHeading
              eyebrow="常见问题"
              title="关于糖心吃瓜，你可能想知道"
              description="从内容来源到投稿方式，先把常见疑问一次说清楚。"
            />
            <div className="mt-8">
              <FaqAccordion items={faqs} />
            </div>
          </div>
        </section>

        <JoinCta />
      </main>

      <Footer />
      <BackToTop />
    </>
  );
}